import { DateField } from '../../shared/field/date_field.js';
import { checkoutDateCopy, type CheckoutDateCopy } from './date_copy.js';
import './checkout_fields.css';

export interface BirthdateFieldCopy {
  readonly label: string;
  /** Abaixo do valor em ficha: onde alterar. */
  readonly editInProfileHint: string;
}

export interface BirthdateFieldProps {
  value?: string;
  onChange: (v: string) => void;
  /** On-file from the server profile ⇒ render read-only. The editable date
   *  picker only shows when the birthdate is missing (still fillable at checkout). */
  readOnly?: boolean;
  /** Formatted on-file value shown in the read-only field. */
  displayValue?: string;
  /** Prefix for the input id/label association — kept unique per traveler in the
   *  multi-traveler drawer. Absent ⇒ the original `pc-birthdate` id. */
  idPrefix?: string;
  copy: BirthdateFieldCopy;
  /** The calendar's words (`CheckoutFieldCopy.date`). */
  dateCopy: CheckoutDateCopy;
  locale: string;
}

export function BirthdateField({
  value,
  onChange,
  readOnly,
  displayValue,
  idPrefix = '',
  copy,
  dateCopy,
  locale,
}: Readonly<BirthdateFieldProps>) {
  const inputId = `${idPrefix}pc-birthdate`;
  if (readOnly) {
    return (
      <div className="ctc-field">
        <label className="ctc-field-label" htmlFor={inputId}>
          {copy.label}
        </label>
        <input
          id={inputId}
          type="text"
          className="ctc-input ctc-input--readonly"
          value={displayValue ?? ''}
          readOnly
          aria-label={copy.label}
        />
        <p className="ctc-input-hint">{copy.editInProfileHint}</p>
      </div>
    );
  }
  // A birthdate lives decades back: the month and year menus, one month at a time.
  return (
    <DateField
      label={copy.label}
      value={value ?? ''}
      copy={checkoutDateCopy(dateCopy, copy.label, locale)}
      locale={locale}
      timeline="past"
      caption="dropdown"
      onChange={onChange}
    />
  );
}
